export default {
  login: {
    title: "中山眼科中心智能预测平台",
    titleImg: "cn",
    desc:
      "中山大学中山眼科中心人工智能与大数据科是国际首个眼科人工智能专科，充分发挥中山眼科中心诊疗技术和临床数据资源的优势，研发国际领先水平的眼病人工智能诊疗平台，制定医疗人工智能在临床的应用标准和方案，引领我国眼病防治的创新服务模式。",
    form: {
      title: "登录平台",
      username: "用户名",
      password: "密码",
      captcha: "验证码",
      login: "立即登录",
      usernameRequired: "请输入用户名",
      passwordRequired: "请输入密码",
      loginError: "登录失败",
      loginErrorNeedModifyPassword: "登录失败，需要修改密码，请联系运营同学",
      loginErrorUsernameOrPassword: "用户名或密码错误",
    },
  },
  gzzoc: {
    returnHome: "返回首页",
    title: "中山眼科中心智能预测平台",
    numberPlease: "请输入数值",
    contentPlease: "请输入内容",
    contentPlease2: "请输入",
    quguangduResult: "屈光度预测结果",
    normalRange: "正常范围：",
    qingdu: "轻度近视：",
    gaodu: "高度近视：",
    yuanshi: "远视：",
    execFailed: "执行失败，请重试",
    sphericalEquivalent: "眼屈光度",
    bcVisualAcuity: "最佳矫正视力",
    prPrevYear: "最近一年的屈光度变化",
    report: "诊断报告",
    diagnosticSuggest: "诊断建议",
    KIDS: "KIDS筛查结果",
    analysis: "病情分析",
    predictedResults: "质量分析结果",
    diagnosticResult: "诊断结果",
    treatmentSuggest: "治疗建议",
    baineizhang: "白内障",
    nurou: "胬肉",
    jiemoxiachuxue: "结膜下出血",
    jiaomoyan: "角膜炎",

    doctorSignature: "医生签名",
    date: "日期",
    upload: "上传",
    downloadSample: "样例下载",
    downloadReport: "下载报告",
    prepareDownload: "准备下载",
    reportTitle: "中山大学中山眼科中心人工智能门诊报告",
    FundusImageQualitReportTitle:
      "中山大学中山眼科中心眼底彩照质量智能分析报告",
    fiveYearResult: "未来{year}年屈光度预测结果",
    myopiaHighRisk: "您未来患高度近视的风险较高，请注意近视防控",
    myopiaLowRisk: "您未来患高度近视的风险较低，请注意近视防控",
    myopiaTip:
      "临床证明有效的近视防控方式：增加户外运动、使用框架眼镜、使用OK镜、使用低浓度阿托品。",
    anemiaPhotoTitle: "拍摄指导",
    anemiaRisk1: "拍摄眼睑：把下眼睑往下扒，暴露粉红色的结膜，距离约50厘米",
    anemiaRisk2: "拍摄拍摄指甲：四指弯曲，暴露甲床，距离约50厘米拍摄",
    leftEyeTitle: "左眼信息",
    rightEyeTitle: "右眼信息",
    eyelidTitle: "眼睑信息",
    nailTitle: "指甲信息",
    eyeImgsTitle: "眼睛信息",
    imgTip: "单眼图像即可分析",
    imgTipData: "单眼数据即可分析",
    modelError: "抱歉，分析出现错误",
    name: "姓名",
    gender: "性别",
    age: "年龄",
    ageUnit: "岁",
    diagnosisTypeTitle: "诊断类型",
    AIimageAnalysisResults: "AI图像分析结果",
    Suggestion: "考虑为",
    Confidence: "置信度",
    AIreferralAdvice: "AI转诊建议",
    blackMoleTitle: "中山大学中山眼科中心眼表黑色肿物模型分析报告",
    ocularEmergencyTriage:"中山大学中山眼科中心分诊模型分析报告",
    missFlag: "未检测到肿物，请重新拍照！",
    triageMessage: "建议",
    triageGrade: "等级",
    Emergency:"紧急",
    SemiEmergency:"一般紧急",
    nonEmergency:"非紧急",
  },
  message: {
    name: "请输入姓名",
    number: "请输入数字",
    maxAge: "请输入正确的年龄",
    age: "请输入年龄",
    phone: "请输入电话号码",
    right_phone: "请输入正确的电话号码",
    nameLimit: "字符不能超过20个",
    ageLimit: "不能超过3位数字",
    img: "请上传图片",
    imgTypeUnknown: "您所上传的图片无法识别，请上传合适的图片文件!",
    pdfTypeUnknown: "文件格式错误，请将文件格式转换为PDF或TIF再上传",
    imgSizeExceed: "上传图片大小不能超过{size}MB!",
    imgUploadSuccess: "上传成功",
    imgUploadFail: "上传失败",
    imgAtLeastOne: "至少上传1张图像",
    imgAtLeastAll: "图片必须全部上传",
    checkInput: "请检查输入项",
    diagnosisType: "请选择诊断类型",
    cameraBrand: "请输入相机厂家",
    cameraModel: "请输入相机型号",
    qualityType: "请选择质量分析类别",
  },
  gzzoc_triage: [
    {
      data_type: "string",
      default_value: null,
      display: "姓名",
      subValue: "姓名",
      key_type: "public",
      name: "name",
      options: null,
      order: 0,
      ques_type: "completion",
      show_type: null,
      value: "",
    },
    {
      data_type: "string",
      default_value: null,
      display: "年龄",
      subValue: "年龄",
      key_type: "public",
      name: "age",
      options: null,
      order: 0,
      ques_type: "completion",
      show_type: null,
      value: "",
    },
    {
      data_type: null,
      default_value: "1",
      display: "性别",
      subValue: "性别",
      key_type: "public",
      name: "gender",
      options: [
        { show_name: "男", value: "1" },
        { show_name: "女", value: "0" },
      ],
      order: 0,
      ques_type: "single_choice",
      show_type: "select",
      value: "1",
    },
    {
      data_type: "title",
      key_type: "event",
      name: "event",
      tip: "",
      title: "事件",
      value: "",
    },
    {
      data_type: null,
      default_value: "0",
      key_type: "public",
      display: "事件",
      subValue: "事件",
      name: "event",
      options: [
        {
          title: "机械性眼外伤",
          options: [
            {
              value: "锐器性机械性眼外伤",
              show_name:
                "锐器（如反弹的铁钉、钢丝、砂轮、剪刀、牙签、指甲划伤等）",
            },
            {
              value: "钝器性机械性眼外伤",
              show_name:
                "钝器（如门把手、水龙头、混凝土块/板、球类、拳头、棍棒、交通意外等）",
            },
            {
              value: "烟花爆竹机械性眼外伤",
              show_name: "烟花爆竹",
            },
          ],
        },
        {
          title: "化学物质入眼",
          options: [
            {
              value: "工业生产",
              show_name: "工业生产（如胶水、机油、漂白粉、腻子粉等）",
            },
            {
              value: "生活意外",
              show_name: "生活意外（如洗洁精、洗衣液、洗发沐浴露、辣椒油等）",
            },
          ],
        },
        {
          title: "异物入眼",
          options: [
            {
              value: "异物入眼",
              show_name: "主要指固体小颗粒，如沙粒、粉尘、小铁渣等",
            },
          ],
        },
        {
          title: "射线性损伤",
          options: [
            {
              value: "射线性损伤",
              show_name: "如紫外线消毒、看电焊、滑雪（未戴防护镜）、沙漠等",
            },
          ],
        },
        {
          title: "热灼伤",
          options: [
            {
              value: "热灼伤",
              show_name: "如热油、铁水、热汤、热水等",
            },
          ],
        },
        {
          title: "无",
          options: [
            {
              value: "0",
              show_name: "无",
            },
          ],
        },
      ],
      ques_type: "single_choice",
      show_type: "select",
      value: "0",
    },
    {
      data_type: "title",
      key_type: "symptoms",
      name: "symptoms",
      tip: "",
      title: "症状",
      value: "",
    },
    {
      data_type: null,
      default_value: "od",
      display: "症状",
      subValue: "症状",
      key_type: "symptoms",
      name: "symptoms",
      options: [
        {
          data_type: null,
          default_value: "od",
          display: "眼别",
          subValue: "眼别",
          name: "eye",
          options: [
            { value: "od", show_name: "右眼" },
            { value: "os", show_name: "左眼" },
            { value: "ou", show_name: "双眼" },
          ],
          order: 0,
          ques_type: "single_choice",
          show_type: "select",
          value: "od",
        },
        {
          data_type: null,
          default_value: "<7天",
          display: "发病时间",
          subValue: "发病时间",
          name: "duration_complaint",
          options: [
            { value: "<7天", show_name: "<7天" },
            { value: ">7天", show_name: ">7天" },
          ],
          order: 0,
          ques_type: "single_choice",
          show_type: "select",
          value: "<7天",
        },
        {
          data_type: null,
          default_value: [],
          display: "视力相关",
          subValue: "视力相关",
          name: "blurredVision",
          options: [
            { value: "视力下降", show_name: "视力下降" },
            {
              value: "黑影遮挡",
              show_name:
                "眼前黑影遮挡（感觉眼前某个方向看不见东西，像黑幕一样遮挡视线）",
            },
            { value: "闪光感", show_name: "眼前闪光感" },
            {
              value: "眼前漂浮物",
              show_name: "眼前漂浮物（感觉眼前有小飞蚊、絮状物在飘动）",
            },
          ],
          children: [
            {
              data_type: null,
              default_value: "几分钟内",
              display: "a.发生快慢",
              subValue: "a.发生快慢",
              name: "how_quickly",
              options: [
                { value: "几分钟内", show_name: "几分钟内" },
                { value: "几小时内", show_name: "几小时内" },
                { value: "几天内", show_name: "几天内" },
                { value: "逐渐持续性", show_name: "＞7天" },
              ],
              order: 0,
              ques_type: "single_choice",
              show_type: "select",
              value: "几分钟内",
            },
            {
              data_type: null,
              default_value: "一过性",
              display: "b.持续时间",
              subValue: "b.持续时间",
              name: "duration",
              options: [
                { value: "一过性", show_name: "一过性" },
                { value: "持续性", show_name: "持续" },
              ],
              order: 0,
              ques_type: "single_choice",
              show_type: "select",
              value: "一过性",
            },
            {
              data_type: null,
              default_value: "显著",
              display: "c.下降程度",
              subValue: "c.下降程度",
              name: "degree",
              options: [
                { value: "显著", show_name: "显著" },
                { value: "中度", show_name: "中度" },
                { value: "轻度", show_name: "轻度" },
              ],
              order: 0,
              ques_type: "single_choice",
              show_type: "select",
              value: "显著",
            },
          ],
          order: 0,
          ques_type: "multi_choice",
          show_type: "select",
          value: [],
        },
        {
          data_type: null,
          default_value: "",
          display: "眼痛",
          subValue: "眼痛",
          name: "eye_pain",
          options: [
            { value: "<7天", show_name: "<7天" },
            { value: ">7天", show_name: ">7天" },
          ],
          children: [
            {
              data_type: null,
              default_value: "",
              display: "性质",
              subValue: "性质",
              name: "pain_nature",
              options: [
                { value: "刺痛", show_name: "刺痛" },
                { value: "胀痛", show_name: "胀痛" },
              ],
              order: 0,
              ques_type: "single_choice",
              show_type: "select",
              value: "",
            },
            {
              data_type: null,
              default_value: "",
              display: "程度",
              subValue: "程度",
              name: "degree",
              options: [
                { value: "尚能忍受", show_name: "尚能忍受" },
                {
                  value: "不能忍受",
                  show_name: "不能忍受（一眨眼转眼珠就眼痛流泪，导致不愿睁眼)",
                },
                {
                  value: "不能忍受，伴同侧头痛、恶心呕吐",
                  show_name: "不能忍受，伴同侧头痛、恶心呕吐",
                },
              ],
              order: 0,
              ques_type: "single_choice",
              show_type: "select",
              value: "",
            },
          ],
          order: 0,
          ques_type: "title_choice",
          show_type: "select",
          value: "",
        },
        {
          data_type: null,
          default_value: [],
          display: "其他",
          subValue:"其他",
          name: "others",
          options: [
            { value: "畏光", show_name: "畏光" },
            { value: "流泪", show_name: "流泪" },
          ],
          order: 0,
          ques_type: "multi_choice",
          show_type: "select",
          value: [],
        },
        {
          data_type: null,
          default_value: "0",
          display: "眼肿睁不开",
          subValue: "眼肿睁不开",
          name: "eye_swelling",
          options: [{ value: "1", show_name: "是" },{ value: "0", show_name: "否" }],
          order: 0,
          ques_type: "single_choice",
          show_type: "select",
          value: "0",
        },
      ],
      order: 0,
      ques_type: "single_choice",
      show_type: "select",
      value: "",
    },
    {
      data_type: "title",
      key_type: "medical_history",
      name: "medical_history",
      tip: "",
      title: "既往史",
      value: "",
    },
    {
      data_type: null,
      default_value: "无",
      display: "全身疾病",
      subValue: "全身疾病史",
      key_type: "medical_history",
      name: "general_disease",
      options: [
        { value: "无", show_name: "无" },
        {
          value: "风湿疾病史",
          show_name: "风湿疾病史（如关节炎、脊柱炎、类风湿）",
        },
      ],
      order: 0,
      ques_type: "single_choice",
      show_type: "select",
      value: "无",
    },
    {
      data_type: null,
      default_value: [0],
      display: "眼科疾病",
      subValue: "眼科疾病史",
      key_type: "medical_history",
      name: "ocular_diseases",
      options: [
        { value: 0, show_name: "无" },
        { value: "白内障", show_name: "白内障" },
        { value: "青光眼", show_name: "青光眼" },
        { value: "佩戴角膜接触镜", show_name: "佩戴角膜接触镜" },
        { value: "眼底病", show_name: "眼底病" },
        { value: "角膜炎", show_name: "角膜炎" },
        { value: "葡萄膜炎", show_name: "葡萄膜炎" },
        { value: "眼外伤史", show_name: "眼外伤史" },
        { value: "高度近视", show_name: "高度近视" },
      ],
      order: 0,
      ques_type: "multi_choice",
      show_type: "select",
      value: [0],
    },
    {
      data_type: null,
      default_value: "0",
      display: "眼科手术",
      subValue: "眼科手术史",
      key_type: "medical_history",
      name: "eye_surgeries",
      options: [
        { value: "0", show_name: "无" },
        { value: "1", show_name: "有" },
      ],
      select: [
        {
          title: "一月内",
          type:'within',
          value: [],
          options: [
            {
              value: "白内障手术",
              label: "白内障手术",
              select: "",
            },
            {
              value: "角膜移植手术",
              label: "角膜移植手术",
              select: "",
            },
            {
              value: "角膜异物剔除手术",
              label: "角膜异物剔除手术",
              select: "",
            },
            {
              value: "胬肉手术",
              label: "胬肉手术",
              select: "",
            },
            {
              value: "青光眼手术",
              label: "青光眼手术",
              select: "",
            },
            {
              value: "视网膜裂孔激光",
              label: "视网膜裂孔激光",
              select: "",
            },
            {
              value: "视网膜手术",
              label: "视网膜手术",
              select: "",
            },
            {
              value: "眼睑手术",
              label: "眼睑手术",
              select: "",
            },
            {
              value: "角膜缝合手术",
              label: "角膜缝合手术",
              select: "",
            }
          ],
        },
        {
          title: "一月前",
          type:'ago',
          value: [],
          options: [
            {
              value: "白内障手术",
              label: "白内障手术",
              select: "",
            },
            {
              value: "角膜移植手术",
              label: "角膜移植手术",
              select: "",
            },
            {
              value: "角膜异物剔除手术",
              label: "角膜异物剔除手术",
              select: "",
            },
            {
              value: "胬肉手术",
              label: "胬肉手术",
              select: "",
            },
            {
              value: "青光眼手术",
              label: "青光眼手术",
              select: "",
            },
            {
              value: "视网膜裂孔激光",
              label: "视网膜裂孔激光",
              select: "",
            },
            {
              value: "视网膜手术",
              label: "视网膜手术",
              select: "",
            },
            {
              value: "眼睑手术",
              label: "眼睑手术",
              select: "",
            },
            {
              value: "角膜缝合手术",
              label: "角膜缝合手术",
              select: "",
            }
          ],
        },
      ],
      order: 0,
      ques_type: "single_choice",
      show_type: "select",
      value: "0",
    },
    {
      data_type: null,
      default_value: null,
      display: "图像",
      key_type: "eye_imgs",
      name: "eyelid_images",
      options: null,
      order: 0,
      ques_type: "file",
      show_type: null,
      value: "",
    },
  ],
  coming: "敬请期待",
  logout: "退出登录",
  startPredict: "开始预测",
  startAnalysis: "开始分析",
  reset: "重置",
  save: "暂存",
  expand: "展开",
  collapse: "收起",
  welcomeUse: "欢迎使用",
  noResult: "无预测结果",
  pleaseRepredict: "请重新预测",
  projectDesc: "项目说明",
  reference: "参考文献",
  pleaseCheckInput: "请检查输入项",
  noPermission: "您暂无权限访问此平台",
  algorithm: "算法",
  requestFailed: "请求失败",
  visionomeIntroduction: "人工智能专家Visionome简介",
  ccIntroduction: "人工智能专家CC-Cruiser简介",
  glaucomaroduction: "青光眼智能诊断筛查平台简介",
  EyeSelect:'请选择对应的手术',
  clinicalData:"临床数据",
  fundusPhotography:"眼底彩照",
  fundusPhotographyTip:"请上传双眼图像",
  notEntered:"未输入",
  requiredField:"必填项",
  return:"返回修改",
  reEnter:"预测下一位",
  noData:"暂无数据",
  pathologicalClassification:"病理分类（预测概率）",
  glomerulosclerosisRatio:"肾小球硬化比例>75%概率",
  prognosticPredictionResults:"预后预测结果",
  prognosticPredictionResults2:"5年内出现肾脏终点事件概率",
  applicationFeedback:"应用反馈",
  yourPosition:"您的职称",
  feedpackFormItem1:"与您判断是否相符",
  feedpackFormItem2:"有无实际病理结果",
  feedpackFormItem3:"与实际病理结果是否相符",
  feedpackFormItem4:"据此预测诊断是否调整现治疗方案",
  feedpackFormItem5:"根据预后预测结果，是否调整患者的随访计划（如增加或适当减少随访次数，提早或适当延长复诊时间等）",
  feedpackFormItem6:"实际病理结果是",
  feedpackFormItem7: "您推测的主要诊断是",
  junior: "低级",
  intermediate: "中级",
  senior: "高级",
  sumbit: "提交",
  yes: "是",
  no: "否",
  yes2: "有",
  confirm: '确定',
  cancel: '取消',
  text1: '输入值超出范围，请输入',
  text2: '请提交应用反馈',
  text3: '数值超出范围不符合规范',
  text4: '提示',
  text5: '是否自动加载最近一次的暂存信息',
  text6: '暂存成功',
  text7: '重置成功',
  no2: "无",
  CKDDes: "本系统诊断结果供医生参考，以临床实际评估为准",
  IgAN: "IgA肾病",
  DN: "糖尿病肾病",
  ANS: "高血压肾病",
  MN: "膜性肾病",
  MCD: "MCD/FSGS",
  ckd2Title: "“眼看肾病”智能诊断系统报告",
  heightTip: "身高单位是米，请输入0-2的数字",
  feedbackTip: "提交反馈成功",
};
